import React from "react";
import { AppleLogo, GooglePlayLogo } from "@phosphor-icons/react";
import Logo from "../components/Logo";

export default function LaunchScreen() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6"
         style={{ background: "linear-gradient(180deg, #11523B 0%, #0E3F2D 100%)", color: "#fff" }}>
      <div className="text-center max-w-md w-full">
        <div className="flex justify-center mb-7">
          <div className="bg-white rounded-3xl p-5 shadow-2xl">
            <Logo size={84} />
          </div>
        </div>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight">MyHandyHub</h1>
        <p className="mt-3 text-lg" style={{ color: "#FFB073" }}>
          Fixing Today, Improving Tomorrow.
        </p>
        <p className="mt-5 text-sm text-white/80 leading-relaxed">
          The UK&apos;s fair-fee marketplace for homeowners and tradespeople.
        </p>
        <div className="mt-9 flex flex-col gap-3">
          <div className="flex items-center justify-center gap-2 rounded-xl px-5 py-3.5"
               style={{ background: "#000" }}>
            <AppleLogo size={28} weight="fill" />
            <div className="text-left">
              <div className="text-[10px] uppercase tracking-widest opacity-70">Download on the</div>
              <div className="text-base font-bold leading-tight">App Store</div>
            </div>
          </div>
          <div className="flex items-center justify-center gap-2 rounded-xl px-5 py-3.5"
               style={{ background: "#000" }}>
            <GooglePlayLogo size={28} weight="fill" />
            <div className="text-left">
              <div className="text-[10px] uppercase tracking-widest opacity-70">Get it on</div>
              <div className="text-base font-bold leading-tight">Google Play</div>
            </div>
          </div>
        </div>
        <p className="mt-8 text-xs text-white/55">myhandyhub.co.uk</p>
      </div>
    </div>
  );
}
